<template>
  <el-row id="app">
    <div  v-if="load_show">
      <load></load>
    </div>
    <headertop></headertop>
    <el-row class="main">
      <el-row>
        <el-col :span="13">
          <el-form class="videoplay "  ref="video">
            <el-row >
              <!-- <span>推荐课程：</span> -->
              <el-carousel indicator-position="none"  direction="vertical">
                  <el-carousel-item v-for="(item,recommend_index) in recommend.video_list" :key="recommend_index">
                    <p @click="recommend_click(recommend_index)" :class="recommend_index == recommend.show ? 'recommend1':'recommend2'">{{item.name}}</p>
                  </el-carousel-item>
                </el-carousel>
            </el-row>

            <!-- <p>推荐视频:
              <span style=" margin-left: 0.625rem;">
                {{video_name}}
              </span>
            </p > -->
            <el-form-item prop="video" style="width: 100%">
              <div class="whole">
                <div class="player-div"  >
                  <el-row :class="video_img_type=='img'? 'video_img1' : 'video_img2'">
                    <img :src="video_img" style="width: 100%;"  />
                  </el-row>
                  <video  ref="videoPlayer" class="video-js video vjs-big-play-centered" controlslist="nodownload noremoteplayback" oncontextmenu = "return false">
                  </video>
                  <div class="player-barrage">
                   <ul class="roll"></ul>
                   <ul class="center"></ul>
                  </div>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="11" style="min-height: 12.625rem;">
            <el-tabs v-model="new_tabs.activeName"   @tab-click="handleClick">
               <el-tab-pane v-for="(item,new_tabs_index) in new_tabs.list" :key="new_tabs_index" :label="item.label" :name="item.name" >
                 <el-row  v-show="item.name=='live'">
                     <el-col >
                        <router-link :to="{name:'Liveintroduce', query: {num:live_info.list.num}}" style="text-align: center;">
                          <!-- <span style=" color: red;position: absolute;top: 0;right: 0;">>>>了解详情</span> -->
                          <img :src="live_info.list.img" style="width: 90%;"  />
                        <el-row  >
                        </el-row>
                        </router-link>
                      </el-col>
                     <!-- el-col >
                       <router-link :to="{name:'Liveintroduce', query: {num:live_info.list.num}}" >
                        <p style="float: right; color: red;">>>>了解详情</p >
                        <el-row  >
                          <img :src="live_info.list.img" style="width: 100%;"  />
                        </el-row>
                      </router-link>

                     </el-col> -->
                 </el-row>
                 <el-row v-show="item.name=='statute'" >
                   <el-row v-if="new_statute_info.list.data.length>0">
                     <el-row  v-for="(item,new_statute_info_index) in new_statute_info.list.data" :key="new_statute_info_index" class="text item" >
                       <el-col :span="21" :offset="1">
                         <div @click="more('fagui',item.file)" >
                           <span style="cursor: pointer;">{{item.name}}</span>
                         </div>
                       </el-col>
                     </el-row>
                     <p v-if="new_statute_info.list.total>5" style="color: red;float: right;cursor: pointer;"  @click="more('fagui','null')">>>>更多</p>
                   </el-row>
                   <el-row v-else style="text-align: center;">
                     <p>暂无法规，敬请期待</p>
                   </el-row>
                 </el-row>
                 <el-row v-show="item.name=='question'" >
                     <el-card class="box-card  mainright" >
                       <div v-for="(item,question_index) in question.list.data" :key="question_index" class="text item" style="margin-bottom: 10px;">
                         <div  style="font-size: 0.875rem;letter-spacing: 3px;" class="itema"  v-html="item.name"  @click="question_show()">
                        </div>
                       </div>
                       <p style="color: red;float: right; cursor: pointer;bottom: 0;" @click="question_show()">>>>更多</p>
                     </el-card>
                 </el-row>
                 <el-row v-show="item.name=='new'">
                   <el-card class="box-card right mainright" >
                     <div v-for="(item,noticelist_index) in noticelist.data" :key="noticelist_index" class="text item" style="margin-bottom: 10px;">
                       <a  style="font-size: 0.875rem;letter-spacing: 3px;"  @click="tankgonggao(item)" class="itema"  v-html="item.info" >
                      </a>
                     </div>
                     <p style="color: red;float: right; cursor: pointer;bottom: 0;" @click="noticelist_show()">>>>更多</p>
                   </el-card>
                 </el-row>
               </el-tab-pane>
             </el-tabs>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-row style=" text-align: center;">
            <el-card class="box-card card ">
            <el-col :span="7" :offset='1'  v-for="(item,index) in lesson_map_list" :key="index">
             <router-link   :to="{name:'coursemap', query: {num:item.file}}" class="link">
                <img :src="item.img" style="height: 3.125rem;" /></br>
                    <span style="color: black;">{{item.name}}</span>
              </router-link>
            </el-col>

            </el-card>
          </el-row>
        </el-col>
        <el-col :span="11" :offset="2">
          <el-row style="text-align: center;">
            <el-card class="box-card card ">
            <el-col :span="7" :offset='1'>
              <router-link to="/minenode"  class="link">
                <img src="../../assets/home_biji.png" style="height: 3.125rem;" /></br>
                <span style="color: black;">我的笔记</span>
              </router-link>
            </el-col>
            <el-col :span="7"  :offset='1'>
            <router-link to="/collect"  class="link">
              <img src="../../assets/home_shoucang.png" style="height: 3.125rem;" /></br>
              <span style="color: black;">我的收藏</span>
            </router-link>
            </el-col>
            <el-col :span="7"  :offset='1'>
              <router-link to="/watch"  class="link">
                <img src="../../assets/home_guankan.png" style="height: 3.125rem;" /></br>
                <span style="color: black;">观看记录</span>
              </router-link>
            </el-col>
            </el-card>
          </el-row>
        </el-col>
      </el-row>
      <el-row >
        <el-col :span="6" >
          <el-card class="box-card card ">
            <div style="border-bottom: 3px dotted #E6A23C;padding: 0 0 10px 0;" @click="Statistics('allnum')">
              <i class="el-icon-data-analysis i" style="background-color: #E6A23C;float: left;"></i>
              <div  style="margin-left: 5px;float: left;font-size: 0.9375rem;">
                <b>总视频数：{{videocount.count}}</b><br />
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" >
          <el-card class="box-card card " style="width: 100%;">
             <div style="border-bottom: 3px dotted #409EFF;padding: 0 0 10px 0;" @click="Statistics('ranking')">
                <i class="el-icon-data-analysis i" style="background-color: #409EFF;float: left;"></i>
                <div  style="margin-left: 5px;float: left;font-size: 0.9375rem; ">
                  <b>我的排名：{{studyorderList.my}}</b><br />
                </div>
              </div>
            <!-- <div class="cardbom" style="overflow-y: auto; ">

              <div v-for="(item,index) in studyorderList.list" :key="index" class="text" >
                <span style="cursor: pointer;" class="left">{{index+1}}.{{item.companyee.name}}</span><span class="right">{{item.time}}</span>
              </div>
            </div> -->
          </el-card>
        </el-col>
        <el-col :span="6" >
          <el-card class="box-card card" >
            <div style="border-bottom: 3px dotted #67C23A;padding: 0 0 10px 0; " @click="Statistics('time')">
              <i class="el-icon-data-analysis i" style=" float: left;  background-color: #67C23A;"></i>
              <div  style="margin-left: 5px;float: left;font-size: 0.9375rem;">
                <b>观看时长：{{studyhistory.time.substring(0, studyhistory.time.indexOf('时')+1 )}}</b><br />
                <!-- <span style="float: left; font-size: x-small;">The length</span> -->
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="6" >
          <el-card class="box-card card left" style="width: 100%;">
            <div style="border-bottom: 3px dotted #F56C6C;padding: 0 0 10px 0;" @click="Statistics('tackall')">
              <i class="el-icon-data-analysis i" style="background-color: #F56C6C;float: left;"></i>
              <div  style="margin-left: 5px;float: left;font-size: 0.9375rem;">
                <b>任务总量：{{traincount.count}} </b><br />
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-row>
    <footerbom></footerbom>
    <!--最新更多公告弹窗-->
    <el-dialog
      title="最新公告"
      :visible.sync="new_tabs.dialogVisible"
      width="40%"
      >
      <div v-for="(item,noticelist_index) in noticelist.data" :key="noticelist_index" class="text item" style="margin-bottom: 10px;">
        <a  style="font-size: 0.875rem;letter-spacing: 3px;"  @click="tankgonggao(item)" class="itema"  v-html="item.info" >
       </a>
        <p style="margin: 2px;color: #a5a5a5;font-size: 10px;">发布时间：{{item.time}}</p>
      </div>
      <el-pagination background small  :hide-on-single-page="value" :pager-count="5" :page-size='noticelist.per_page' :current-page='noticelist.current_page'
        layout="prev, pager, next" :total='noticelist.total' class="center" style="padding: 0;margin:0;"  @current-change="(val) => handleCurrentChange(val)">
      </el-pagination>
    </el-dialog>
    <!--最新详情公告弹窗-->
    <el-dialog :visible.sync="dialogVisible" >
       <div class="text item" v-html="notice_list.content">
            <!-- <a class="itema"   >
            </a> -->
       </div>
        <p style="margin-top: 10px;color: #a5a5a5;font-size: 10px;">发布时间：{{notice_list.time}}</p>
    </el-dialog>

    <!--统计详情弹窗-->
    <el-dialog :visible.sync="statistics_list.dialogVisible" :title="statistics_list.title">
      <div class="cardbom" v-if="statistics_list.type=='allnum'">
        <el-table
            :data="videocount_list"
            stripe
            style="width: 100%;max-height: calc(100vh - 350px);overflow: auto;">
            <el-table-column
              prop="name"
              label="视频名称"
              min-width="400"
            >
             <template slot-scope="videocount_list">
                <span @click="videolist(videocount_list.row.num,'0')">{{videocount_list.row.name}}</span>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="cardbom" v-if="statistics_list.type=='ranking'">
        <el-table
            :data="studyorderList_list"
            stripe
            style="width: 100%;height: calc(100vh - 350px);overflow: auto;">
            <el-table-column
              prop="name"
              label="视频名称"
              min-width="400"
            >
             <template slot-scope="studyorderList_list">
                <span>{{studyorderList_list.row.companyee.name}}</span>
                <span style="float: right;">{{studyorderList_list.row.time}}</span>
              </template>
            </el-table-column>
          </el-table>
      </div>
      <div class="cardbom" v-if="statistics_list.type=='time'">
        <!-- <div v-for="(item,index) in studyhistory.data" :key="index" class="text" @click="videolist(item.num,item.type)">
          <a href="#" class="anone hide">{{item.name }}</a>
        </div> -->
        <el-table
            :data="studyhistory_list"
            stripe
            style="width: 100%;max-height: calc(100vh - 350px);overflow: auto;">
            <el-table-column
              prop="name"
              label="视频名称"
              min-width="400"
            >
             <template slot-scope="studyhistory_list">
                <span @click="videolist(studyhistory_list.row.num,'0')">{{studyhistory_list.row.name}}</span>
              </template>

            </el-table-column>
          </el-table>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="question_dialogVisible" class="question_info" width="80%" >
       <!-- <div class="text item" >
            <p v-html="question_info.name" style="color: #FF0000;font-size: 22px;">
            </p>
            <p class="itema" v-html="question_info.answer" style="padding:5px 0px;text-decoration:none;"></p>
            <p style="padding: 10px 0;color: #a5a5a5;font-size: 10px;">发布时间：{{question_info.time}}</p>
       </div> -->
       <el-input placeholder="请输入关键字,搜索相关问题" prefix-icon="el-icon-search" @keyup.enter.native="search_click()"
       	v-model.trim="question.search" style="width: 100%;margin-top: 2.25rem; margin-bottom: 0.625rem;"></el-input>
       <el-row :style="{height:dialog_Height}" class="over">
            <div v-for="(item,question_index) in question.info" :key="question_index" class="text item" style="margin-bottom: 10px;">
              <!-- <a  style="font-size: 0.875rem;letter-spacing: 3px;"   class="itema"  v-html="item.name" >
             </a> -->
             <el-card class="box-card  mainright" >
             <h4 v-html="item.name"></h4>
             <el-row  v-html="item.answer"></el-row>
             </el-card>
            </div>
       </el-row>
       <div class="block center">
         <el-pagination @size-change="(val) => handleSizeChange_question(val)"
           @current-change="(val) => handleCurrentChange_question(val)" :current-page="question.currentPage"
           :page-sizes="[10, 20, 30, 40]" :page-size="question.pageSize"
           layout="total, sizes, prev, pager, next, jumper" :total="question.total">
         </el-pagination>
       </div>
    </el-dialog>

    <el-dialog
          :title="new_function.title"
          :visible.sync="new_function.dialogVisible"
          width="40%"
          :before-close="handleClose">
          <p  v-html="new_function.list" ></p >
          <el-row style="margin-bottom: 1.25rem;">
            <el-col :span="12">
              <span style="padding: 10px 0;color: #a5a5a5;font-size: 10px;">发布时间：{{new_function.time}}</span>
            </el-col>
            <el-col :span='12'>
              <span style="float: right;color: #E6A23C;cursor: pointer;" @click="new_function_ok('fuwuhao')">我已阅读</span>
            </el-col>
          </el-row>
        </el-dialog>
  </el-row>
</template>

<script>
  import Header from '../../components/index/public/NavHeader.vue';
  import Footer from '../../components/index/public/NavFooter.vue';
  import load from '../../components/load.vue';
  export default {
    name: 'App',
    data() {
      return {
        dialog_Height:window.innerHeight * 0.6 + 'px',
        load_show:false,
        recommend:{
          video_list:[],
           show:0,
           video:[]
        },
        lesson_map_list:[],
        video_img:'',
        video_img_type:'img',
        video_status:false,
        video_name:'',
        file_list:{
          list:[],
          show_list:[]
        },
       player: null,
       videoOptions: {
         lang: 'zh-CN',
         autoplay: true,//自动播放
         controls: true,//用户可以与之交互的控件
         loop:true,//视频一结束就重新开始
         muted:true,//默认情况下将使所有音频静音
         // aspectRatio:"16:9",//显示比率
         // preload:false,//预加载
         notSupportedMessage: '此视频暂无法播放，请稍后再试',
         errorDisplay: false,
         fluid: true,
         controlBar: {
           playToggle:true,
           volumePanel:true,
           currentTimeDisplay:true,
           progressControl:false,
         },
         sources:[{
           src: "",
           type: ""
         }],
       },

        //直播
        live_info:{
          list:[]
        },
        //法规
        new_statute_info:{
          dialogVisible:false,
          list:[]
        },
        statistics_list:{
          dialogVisible:false,
          list:[],
          title:"",
          type:''
        },
        new_tabs:{
          list:[{
            label:'正在直播',
            name:'live'
          },
          {
            label:'法规',
            name:'statute'
          },
          {
            label:'精彩问答',
            name:'question'
          },
          {
            label:'最新公告',
            name:'new'
          },
          ],
          activeName:'statute',
          dialogVisible:false
        },
         activeName: 'first',
        video_Solicitation:{
          // dialogVisible:true,
        },
        //服务号弹窗
        new_function:{
          dialogVisible:false,
          list:'',
          url:'../../assets/fuwuhao_erweima.jpg',
          checked:false,
          num:'',
          time:'',
          title:''
        },
        value: false,
        dialogVisible: false,
        question: {
          list:[],
          currentPage: 1, // 当前页码
          total: 0, // 总条数
          pageSize: 10,
          search: '',
          info:[]
        },
        question_dialogVisible: false,
        teacherList:[],
        studyorderList:[],
        studyhistory:[],
        traincount:[],
        videocount:[],
        noticelist:[],
        traincount_status:'',
        notice_list:[],//公告详情
        question_info:[],
        anhui_show:false,
       }
    },
    components: {
      headertop: Header,
      footerbom: Footer,
      load:load
    },
    mounted: function() {
      this.check_new()
      this.get_video_count()
      this.get_study_order()
      this.get_study_history()
      this.get_train_count()
      this.get_notice_list('1')
      this.get_question_list('1')
      this.statute(5)//法规
      this.get_file_list()
      this.get_live_list()
      this.get_lesson_map()//地图列表
      if(this.$store.state.info.company.name=='北京睿知而行科技有限公司-药知企业教育平台'){
        this.anhui_show=true
      }
      this.get_video_hot()
      // window.onresize = () => {
      //   this.change_height()
      // }
      //  this.change_height()
       // this.get_teacher_info()
    },
    methods: {
      handleSizeChange_question(val) {
        this.question.currentPage = 1
        this.question.pageSize = val
        this.get_question_all()
      },
      handleCurrentChange_question(val) {
        this.question.currentPage = val
        this.get_question_all()
      },
      search_click(){
        this.question.currentPage = 1
        this.get_question_all()
      },
      get_question_all(){
        let _this=this;
        _this.axios.get('/v2/user_question/get_list',{
          params: {
            'keyword':_this.question.search,
            'page':_this.question.currentPage,
            'limit':_this.question.pageSize
          }
        }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.question.info=res.data.data.data
              _this.question.total=res.data.data.total
              _this.question.currentPage=res.data.data.current_page
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_data(){
         var that = this;
            const nowDate = new Date();
                const date = {
                    // year: nowDate.getFullYear(),
                    month: nowDate.getMonth() + 1,
                    date: nowDate.getDate(),
                }
                const day = date.date>10?date.date:'0'+date.date
                that.get_video_hot_click(day%10)

        },
      recommend_click(index){
        let _this=this
        _this.get_video_hot_click(index)

      },
      get_lesson_map(){
        let _this = this;
          _this.axios
        .get("/v2/user_resource/lesson_map", {
          params: {limit:3},
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.lesson_map_list=res.data.data.data
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      start_player(){
            let _this=this
            if(_this.player){
              _this.player.src({type:_this.videoOptions.sources[0].type, src:_this.videoOptions.sources[0].src})
              _this.player.load()
            }else{
              _this.$nextTick(()=>{
                _this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions, function onPlayerReady() {

                })
              })
            }
          },
      get_video_hot_play(num){
              let _this=this
              _this.axios.get('/v2/user_resource/get_video_hot',{params: {video:num},}).then(function(res) {
                if(res.status=='200'){
                  if(res.data.code=='1'){
                    _this.video_name=res.data.data.name
                    _this.video_img=res.data.data.img
                    _this.video_img_type='img'
                    _this.videoOptions.sources[0].type=res.data.data.type
                    _this.videoOptions.sources[0].src='/v2/user_resource/play?key='+localStorage.authorization+'&type=0&num='+res.data.data.num
                    setTimeout(() => {
                      _this.video_img_type='video'

                      _this.start_player()
                    },5000)

                  }else{
                    _this.$message.error(res.data.msg)
                  }
                }else{
                  _this.$message.error('服务器内部错误')
                }
              }).catch(function(error) {
                _this.$message.error('服务器内部错误')
              });
            },
            get_video_hot(){
              let _this=this
              _this.axios.get('/v2/user_resource/get_video_hot_many').then(function(res) {
                if(res.status=='200'){
                  if(res.data.code=='1'){
                    for(let i=0;i<res.data.data.length;i++){
                      let data={
                        name:res.data.data[i].name
                      }
                      _this.recommend.video_list[i]=data
                    }
                    _this.recommend.video=res.data.data
                    _this.get_data()
                    // _this.get_video_hot_click(0)
                    // _this.video_info(_this.recommend.video[0],0)
                  }else{
                    _this.$message.error(res.data.msg)
                  }
                }else{
                  _this.$message.error('服务器内部错误')
                }
              }).catch(function(error) {
                _this.$message.error('服务器内部错误')
              });
            },
            get_video_hot_click(num){
              this.recommend.show=num
              this.get_video_hot_play(num)
            },
      more(type,num){
        if(type=='file'){
          this.$router.push({path:'/file'})
        }else{
          if(num=='null'){
            this.$router.push({path:'/statute_map?num='})
          }else{
            this.$router.push({path:'/statute_map?num='+num})
          }

        }
      },
      get_live_list(){
        let _this = this;
          _this.axios
        .get("/v2/user_live/get_list", {
          params: {page:1,limit:1,'keyword':''},
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
            _this.live_info.list=res.data.data.data[0];
            _this.get_live_info()
            } else {
              _this.$message.error("服务器内部错误");
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },
      get_live_info(){
        let _this = this;
              _this.axios
            .get("/v2/user_live/get_info", {
              params:{'num':_this.live_info.list.num},
            })
            .then(function (res) {
              if (res.status == "200") {
                if (res.data.code == "1") {
                  // _this.liveList=res.data.data;
                  // _this.rawHtml=res.data.data.info;
                  // _this.liveList.status=1
                 let yy = new Date().getFullYear();
               　　let mm = new Date().getMonth()+1;
               　　let dd = new Date().getDate();
               　　let hh = new Date().getHours();
               　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
                   if (mm < 10) mm = "0" + mm;
                   if (dd < 10) dd = "0" + dd;
                   if (hh < 10) hh = "0" + hh;
                   if (mf < 10) mf = "0" + mf;
               　　let gettime = yy+'-'+mm+'-'+dd+' '+hh+':'+mf;
                   if( res.data.data.status==0){
                     if(res.data.data.time>gettime){
                       _this.new_tabs.list[0].label='直播预告'
                       _this.new_tabs.activeName='live'
                     }else{
                       _this.new_tabs.list = _this.new_tabs.list.filter((item) => {
                         return item.name != 'live';
                       });
                     }
                   }else{
                     _this.new_tabs.list[0].label='正在直播'
                     _this.new_tabs.activeName='live'
                   }
                  // _this.setitem();
                  // if(_this.liveList.type_price==0){
                  //   _this.liveList.type_price="免费"
                  // }else{
                  //   _this.liveList.type_price="付费"
                  // }
                } else {
                  _this.$message.error(res.data.msg);
                }
              } else {
                _this.$message.error("服务器内部错误");
              }
            });

      },
      get_file_list(){
        let _this = this;
          _this.axios
        .get("/v2/user_resource/get_file_type",
        {params:{type:0}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.file_list.list=res.data.data
                _this.file_list.show_list=_this.file_list.list
                // _this.file_list.show_list.push(_this.file_list.list)
                // _this.file_list.show_list.push(_this.file_list.list[1])
                // _this.file_list.show_list.push(_this.file_list.list[2])
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      statute(limit){
        let _this = this;
          _this.axios
        .get("/v2/user_resource/get_document",
        {params:{limit:limit}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.new_statute_info.list=res.data.data
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      Statistics(type){
        let _this=this
        _this.statistics_list.dialogVisible=true
        _this.statistics_list.type=type
        if(type=='time'){
          _this.statistics_list.title='观看记录'
        }else if(type=='allnum'){
          _this.statistics_list.title='最新视频'

        }else if(type=='ranking'){
          _this.statistics_list.title='我的排名'
        }else{
          this.$router.push({path:'/tasklist'})
        }
      },
      noticelist_show(){
        let _this=this
        _this.new_tabs.dialogVisible=true
      },
      handleClick(tab, event) {

      },
      check_new(){
        let _this=this
        _this.axios.get("/v2/user/get_new_notice").then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.new_function.dialogVisible=true
              _this.new_function.title=res.data.data.title
              _this.new_function.list=res.data.data.content
              _this.new_function.time=res.data.data.time
              _this.new_function.num=res.data.data.num
            }
          }else{

          }
        });
      },

      new_function_ok(type){
        let _this=this
        var data={
          'num':_this.new_function.num
        }
        if(type=='fuwuhao'){
          _this.axios.post("/v2/user/save_new_notice",{data:data}).then(function (res) {
            if (res.status == "200") {
              if (res.data.code == "1") {
                _this.new_function.dialogVisible=false
              }
            }
          });
        }else{
          // _this.video_Solicitation.dialogVisible=false
        }
      },

      train_notice() {
        const h = this.$createElement;
        this.$notify({
          title: '任务提示',
          message: h('b', { style: 'color: red'}, '您有未完成任务请及时处理'),
          duration: 0
        })
      },
      tankgonggao(item){
        this.dialogVisible=true;
        this.notice_list=item
        this.notice_list.content=item.content.replace(/(<\/?a.*?>)|(<\/?span.*?>)/g, '');
        // this.notice_list.content=item.content.slice(0,a)+item.content.slice((b+1),item.content.length)
      },

      tankquestion(item){
        let _this=this
        _this.axios
        .get("/v2/user_question/get_info",
        {params:{num:item.num}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.question_dialogVisible=true
              _this.question_info=res.data.data
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },


      videolist(num,type){
        this.$router.push({path:'/courseplay',query:{num: num,type: type,resource:'v'}})
      },

      question_show(){
        // this.$router.push({path:'/question'})
        this.question_dialogVisible=true
        this.get_question_all()
      },

      handleCurrentChange(num){
        this.get_notice_list(num);
      },

      question_handleCurrentChange(num){
        this.get_question_list(num);
      },
      //公告
      get_notice_list(num){
        let _this = this;
        _this.axios
        .get("/v2/user/get_notice_list",
        {params:{page:num,limit:'3'}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.noticelist=res.data.data;
              _this.noticelist.per_page=parseInt( _this.noticelist.per_page);
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      get_question_list(num){
        let _this = this;
          _this.axios
        .get("/v2/user_question/get_list",
        {params:{page:num,limit:'4'}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.question.list=res.data.data;
              _this.question.per_page=parseInt( _this.question.per_page);
            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });
      },

      //总视频
      get_video_count(){
        let _this = this;
          _this.axios
        .get("/v2/user/get_video_count",
        {params:{limit:'10'}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.videocount=res.data.data;
              _this.videocount_list=res.data.data.list;
               _this.videocount.per_page=parseInt( _this.videocount.per_page);

            } else {
              _this.$message.error(res.data.msg);
            }
          } else {
            _this.$message.error("服务器内部错误");
          }
        });

      },
      //任务总量
      get_train_count(){
      let _this = this;
        _this.axios
      .get("/v2/user/get_train_count",
      {params:{limit:'1'}})
      .then(function (res) {
        if (res.status == "200") {
          if (res.data.code == "1") {
            _this.traincount=res.data.data
             _this.traincount.per_page=parseInt( _this.traincount.per_page)
            if(!_this.traincount.status ){
              _this.train_notice()
            }
          } else {
            _this.$message.error(res.data.msg)
          }
        } else {
          _this.$message.error("服务器内部错误")
        }
      });

      },
       //观看记录
      get_study_history(){
        let _this = this;
          _this.axios
        .get("/v2/user/get_study_history",
        {params:{page:'1',limit:'10'}})
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.studyhistory=res.data.data
              _this.studyhistory_list=res.data.data.data
              _this.studyhistory.per_page=parseInt( _this.studyhistory.per_page)
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      //排名
      get_study_order(){
        let _this = this;
          _this.axios
        .get("/v2/user/get_study_order")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.studyorderList=res.data.data
              _this.studyorderList_list=res.data.data.list
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      teacherclick(num){
        this.$router.push({path:'/TeacherCurriculumList',query:{num:num}})
      },
      get_teacher_info(){
        let _this = this;
          _this.axios
        .get("/v2/user_teacher/get_list", {
          params:{page:'1',limit:'5'},
        })
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.teacherList=res.data.data.data
              _this.get_study_order()
              _this.get_study_history()
              _this.get_train_count()
              _this.get_video_count()
              _this.get_notice_list('1')
            } else {
              _this.$message.error(res.data.msg)
            }
          } else {
            _this.$message.error("服务器内部错误")
          }
        });
      },
      handleClose(done) {
        done();
      },
      new_function_handleClose(done){
         this.$message({
            message: '请点击我已阅读完毕，即可',
            type: 'warning'
          });
      },
      // 跳转页面方法
      /* 新标签页*/
      goPage(url) {
        window.open(url, '_blank');
      },
      /* 原页面 */
      goTo(url) {
        this.$router.push(url);
      }, //高度
      change_height() {
        let _this = this
        let imgw = _this.$refs.img.$el.offsetWidth;
        let imgh = _this.$refs.img.$el.offsetHeight;
        _this.$refs.img.$el.style.height = imgw / 6 * 4 + 30 + 'px'
      },

    }
  }
</script>

<style scoped>
  .video_img1{
       width: 100%;
       position: absolute;
       z-index: 999;
    }
    .video_img2{
        width: 100%;
       position: absolute;
        z-index: -1;
    }
  .link{
    text-decoration: none;
  }
  .buhuanhang{
     display: inline-block;
      white-space: nowrap;
      width: 100%;
      overflow: hidden;
      text-overflow:ellipsis;
  }
  .main {
    min-height: calc(100vh - 300px);
    width: 70%;
    padding: 20px;
    margin: 0 15%;
    z-index: 100;
    background-color: white;
    overflow: hidden;
  }

  .question_info >>> .el-dialog__body {
      padding: 0px 20px;
  }

  .question_info >>> .el-dialog__header {
      padding: 0px 20px 10px;
  }

  .hide{
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
     display: block;
  }

  .mainleft {
    width: calc(70% - 25px);
    margin-right: 10px;
    margin-top: 10px;
    overflow: hidden;
  }


  .medium {
    width: calc(100% - 40px);
    padding: 20px;
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 20px;
    margin: 0;
    position: absolute;
    bottom: 0;
    left: 0;
  }

  .teacon {
    color: white;
    width: 100%;
    font-size: 14px;
    line-height: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    /* // 作为弹性伸缩盒子模型显示。 */
    -webkit-line-clamp: 4;
    /* // 显示的行 */
    -webkit-box-orient: vertical;
    /* // 设置伸缩盒子的子元素排列方式--从上到下垂直排列 */
  }

/*  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  } */

  .mainright {

    /* min-height: 1000px; */
  }

  .card {
    margin: 15px 0;
    /* width: calc(50% - 10px); */
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .card div {
    padding-top: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    margin-bottom: 5px;
  }

  .item {
    margin-bottom: 20px;
  }

  .itema:hover {
    color: #409EFF;
    text-decoration: underline;
    cursor: pointer;
  }

  .el-card__header div {
    text-align: center;

  }
  >>>.el-card__header{
    padding: 0.375rem;
  }
  .cardbom {
    margin: 10px 0;
    padding: 0 10px;
      overflow: hidden;

  }

  .el-pagination {
    width: 100%;
  }

  .i {
    width: 40px;
    height: 40px;
    color: white;
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    border-radius: 5px;
  }

  .anone {
    color: black;
    text-decoration: none;

  }

  .anone:hover {
    color: black;
    text-decoration: none;
  }

  .anone:active {
    color: black;
    text-decoration: none;
  }
  a{
    overflow:hidden;
    	text-overflow:ellipsis;
    	display: -webkit-box;
    	-webkit-box-orient: vertical;
    	-webkit-line-clamp:2;
  }



  /* 视频播放 */
  .videoplay {
    max-width: 100%;
    width: 75%;
  }

  .video {
    display: block;
    height: 100%;
    position: absolute;
  }

  .whole {
    padding-bottom: 56.25%;
    height: 0;
    position: relative;
  }

  .el-form-item {
    padding: 0;
    margin: 0;
  }

  .el-form-item,
  .el-form-item__content,
  .whole,
  .video {
    width: 100%;
  }
  .el-carousel__item p {
      /* color: black; */
      font-size: 15px;
      opacity: 0.75;
      line-height: 2.7rem;
      margin: 0;
      display:-webkit-box;

        text-overflow:ellipsis;

        overflow:hidden;

        -webkit-line-clamp: 1;

        -webkit-box-orient:vertical;
    }

    .el-carousel__item:nth-child(2n) {
      background-color: white;
    }

    .el-carousel__item:nth-child(2n+1) {
      background-color: white;
    }
    >>>.el-carousel__container {
      height: 2.7rem;
      /* height: 500px !important; */
    }
    .recommend1{
      color: blue;
      cursor: pointer;
    }
    .recommend2{
      color: black;
      cursor: pointer;
    }
    .over{
      overflow: auto;
      overflow-x:hidden;
    }
</style>



// WEBPACK FOOTER //
// src/view/index/Home.vue